export const USER_ID_KEY = "userID"
export const USER_ROLE = "user_rls"
export const USER_INFO_KEY = "userInfoData"
export const KEY_CODE = "4zajsvnjkqsdfzea"
export const PROMPT2LLM_KEY = "PROMPT2LLM"
export const ONBOARDING_CONFIG_KEY = 'app_onboarding_completed';

export const MAIL_CHECKBOX_KEY = "MAIL_CHECKBOX_DATA"
export const MAIL_LANGUAGE_KEY = "MAIL_LANGUAGE_VALUE"
export const MAIL_TITLE_CHECKBOX_KEY = "MAIL_TITLE_CHECKBOX_VALUE"
export const MAIL_ACC_CHECKBOX_KEY = "MAIL_ACC_CHECKBOX_VALUE"
export const JOB_CHECKBOX_KEY = "JOB_CHECKBOX_DATA"
export const INCLUDE_LOCALISATION_KEY = "INCLUDE_LOC_CHECKBOX_DATA"
export const EXCLUDE_LOCALISATION_KEY = "EXCLUDE_LOC_CHECKBOX_DATA"
export const TECHNOLOGY_KEY = "COMPANY_TECH"
export const DOMAINE_CHECKBOX_KEY = "DOMAIN_CHECKBOX_DATA"
export const INCITATION_KEY = "INCITATION_DATA"
export const ACCROCHE_KEY = "ACCROCHE_DATA"
export const TITRE_MAIL_KEY = "MAIL_DATA"
export const SERVICE_VALUE_KEY = "SERVICE_VALUE"

export const DEST_SAVING_STATE = "DEST_SAVING_STATUS"
export const SENDER_SAVING_STATE = "SENDER_SAVING_STATUS"
export const FOLLOWUP_SAVING_STATE = "FOLLOWUP_SAVING_STATUS"

export const RECIPIENT_KEY = "RECIPIENT_DATA"
export const SENDER_KEY = "SENDER_DATA"
export const DOC_ID_KEY = "DOC_ID_VALUE"

export const CRM_API_KEY = "CRM_KEY_VALUE"
export const CRM_FIRST_APPARITION_KEY = "CRM_HOME_PAGE_VALUE"

export const SF_CREDS_DATA="SF_CREDS"
export const AP_CREDS_DATA="AP_CREDS"
export const HS_CREDS_DATA="HS_CREDS"
export const GS_CREDS_DATA="GS_CREDS"

export const V2_RECIPIENT_KEY = "RECIPIENT_DATA_V2"
export const V2_SENDER_KEY = "SENDER_DATA_V2"
export const V2_MAIL_KEY = "MAIL_DATA_V2"
export const V2_CAMPAIGN_KEY = "CAMPAIGN_DATA_V2"
export const RAIS_COMM_KEY = "RAIS_COMM_KEY"

export const CAMPAGN_LOAD_STATE = "CAMPAGN_LOADER_KEY"

export const FOLLOW_UP_DATA = "FOLLOW_UP"
export const HIST_DATA4EVAL = "HISTORY_DATA4EVAL"
export const HISTORY_DATA4CORRECTION = "HISTORY_DATA4CORRECTION_KEY"
export const HIST_SEGMENTED_BY_COMPAIGN_NAME = "HIST_SEGMENTED_BY_COMPAIGN_NAME_KEY"

export const BART_FORM_DATA = "formData"
export const SLM_FORM_DATA = "SLM_DATA"

export const EVALUATION_DATA_KEY = "_EVALUATIONDATA"

export const BLOCK_VALUE_KEY_LAST_SELECTED = "BLOCK_VALUE_KEY_LAST_SELECTED"
export const BLOCKS_ALL_KEY = "ALL_DATA_BLOCKS"

export const CURRENT_COLOR_THEME_USED = "CCTU"

export const ACTIVE_MENU_KEY = "ACTIVE_MENU";
export const MAIL_CHOSED4_TEACHER = "MAIL_CHOSED4_TEACHER_KEY"

export const DASHBOARD_STATE = "DASHBOARD_STATE_KEY"
export const ONBOARDING_HIST = "ONBOARDING4HISTORY_KEY"

export const QA_TIPS4_USER_KEY = "QA_TIPS4USER"

export const GAME_COACH_EVOLUTION = "COACH_EVOLUTION_KEY_DATA"
export const COACH_DATA4LEVELUP = "COACH_DATA4LEVELUP_KEY_DATA"
export const PROFESSEUR_DATA4LEVELUP = "PROFESSEUR_DATA4LEVELUP_KEY_DATA"

export const TAG_SELECTOR_DATA = "TAG_SELECTOR_KEY_DATA"

export const CAMPAIGN_RUNING_KEY = "CAMPAIGN_STATE_DATA"
export const BLOCK_SELECTED_ALL_INFOS = "BLOCK_SELECTED_ALL_INFOS"

export const EMAIL_PROVIDER_CONFIG = "EMAIL_PROVIDER_CONFIG_KEY"

export const ADMIN_COMPANY_NAME = "ADM_CN"
export const ADMIN_COMPANY_DEPARTEMENT = "ADM_DPM"
export const QUICK_SEND_MODE_KEY = "QUICK_SEND_MODE"
export const VALUE_BLOCK_DRAFT_KEY = "VALUE_BLOCK_DRAFT_KEY"
export const WELCOME_SEEN_KEY = 'welcome_seen';
export const OPEN_CORRECTED_MAIL_KEY = "open_corrected_mail_for_id";

export const ESTIMATED_PROSPECT_COUNT_KEY = "ESTIMATED_PROSPECT_COUNT_KEY";

export const CAMPAIGN_EMAIL_COUNT_KEY = "CAMPAIGN_EMAIL_COUNT_KEY";
export const FIRST_ESTIMATION_NOTICE_SEEN_KEY = 'first_estimation_notice_seen';
export const EXCLUDED_COMPANIES_KEY = "EXCLUDED_COMPANIES_DATA";
export const INCLUDED_COMPANIES_KEY = "INCLUDED_COMPANIES_DATA";
// Brouillon du ciblage (page Destinataire), conservé même sans enregistrement
export const EMPLOYEE_RANGES_KEY = "EMPLOYEE_RANGES_DATA";
export const USE_EMPLOYEE_FILTER_KEY = "USE_EMPLOYEE_FILTER_KEY";
export const PENDING_ESTIMATION_KEY = "PENDING_ESTIMATION_KEY";
export const EXCLUDED_GEOGRAPHY_KEY = "EXCLUDED_GEOGRAPHY_DATA";
export const EXCLUDE_CRM_CONTACTS_KEY = "EXCLUDE_CRM_CONTACTS_KEY";
export const EXCLUDE_PREVIOUS_CAMPAIGN_CONTACTS_KEY = "EXCLUDE_PREVIOUS_CAMPAIGN_CONTACTS_KEY";
export const TRIAL_ALREADY_USED_KEY = "TRIAL_ALREADY_USED_KEY";
export const PENDING_AUTH_KEY = "PENDING_AUTH_DATA";